import React from 'react'

import workExperience from '../../../assets/work-experience.svg'

import Card from '../../components/Card'
import Education from '../../containers/Education'
import EducationHeading from '../../components/EducationHeading'
import SkeletonEducationScene from '../../skeletons/SkeletonEducationScene'
import EducationList, { EducationItemForm, EducationItemPreview } from '../../compounds/EducationList'

const EducationScene = () => (
  <Education>
    {props => (
      <Card title="Education" imageUrl={workExperience} width={550}>
        <EducationHeading />

        <Choose>
          <When condition={props.loading}>
            <SkeletonEducationScene />
          </When>

          <Otherwise>
            <EducationList addBlankEducation={props.addBlankEducation} submitEducation={props.submitEducation}>
              <For each="education" of={props.educations}>
                <Choose>
                  <When condition={education.editing}>
                    <EducationItemForm
                      key={education.formName}
                      form={education.formName}
                      initialValues={education}
                      isNew={education.isNew}
                      searchUniversities={term => props.searchUniversities(education.id || education.tempId, term)}
                      searchingUniversities={education.searchingUniversities}
                      universitiesSearchResults={education.universitiesSearchResults}
                      searchDegrees={term => props.searchDegrees(education.id || education.tempId, term)}
                      searchingDegrees={education.searchingDegrees}
                      degreesSearchResults={education.degreesSearchResults}
                      toggleEditing={editing => props.toggleEditing(education.id, editing)}
                      deleteBlankEducation={() => props.deleteBlankEducation(education.tempId)}
                      updateEducation={(data, resolve, reject) => props.updateEducation(education.id, data, resolve, reject)}
                      createEducation={props.createEducation}
                    />
                  </When>
                  <Otherwise>
                    <EducationItemPreview
                      key={education.id}
                      deleteEducation={() => props.deleteEducation(education)}
                      toggleEditing={editing => props.toggleEditing(education.id, editing)}
                      {...education}
                    />
                  </Otherwise>
                </Choose>
              </For>
            </EducationList>
          </Otherwise>
        </Choose>
      </Card>
    )}
  </Education>
)

export default EducationScene
